import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl } from '../data/copy';
import { trackPixelEvent } from '../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  size?: 'default' | 'large';
  variant?: 'primary' | 'outline';
  className?: string;
}
const variants = {
  primary: 'bg-ember text-paper-soft shadow-[0_6px_0_0_#7A3410] hover:bg-ember-hover focus-visible:outline-ember',
  outline: 'border-2 border-pine text-pine hover:bg-pine hover:text-paper-soft focus-visible:outline-pine'
};
export function CtaButton({
  children,
  href = checkoutUrl,
  size = 'default',
  variant = 'primary',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'large' ? 'px-8 py-5 text-base sm:text-lg' : 'px-6 py-4 text-sm sm:text-base';
  const handleClick = () => {
    // Solo i pulsanti che portano al checkout contano come inizio acquisto.
    if (href !== checkoutUrl) return;
    trackPixelEvent('InitiateCheckout', {
      content_name: 'Pallamano 360',
      value: 19,
      currency: 'EUR'
    });
  };
  return <a href={href} onClick={handleClick} className={`group inline-flex items-center justify-center gap-3 rounded-xl font-display font-semibold uppercase tracking-[0.06em] transition-[background-color,color,transform,box-shadow] duration-150 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 active:translate-y-1 active:shadow-none ${variants[variant]} ${sizing} ${className}`} data-id="element-53" data-mp="39yhozs5wpped">
      <span data-id="element-54" data-mp="3swasavkg01ca">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" strokeWidth={2.4} aria-hidden="true" data-id="element-55" data-mp="3svivjhf3zxkf" />
    </a>;
}